import { Link } from "react-router";
import { Badge } from "@/components/ui/badge";
import { useServiceTypes } from "@/api/get-service-types";
import { useProfessions } from "@/api/get-professions";

export const ServiceBadge = ({ title, searchTerms = "" }) => {
    const { data: serviceTypes } = useServiceTypes();
    const { data: professions } = useProfessions();

    const terms = [title, ...searchTerms.split(",")]
        .map((term) => term.trim().toLowerCase())
        .filter(Boolean);

    const typeIds = [
        ...(professions ?? [])
            .filter((profession) =>
                terms.some((term) =>
                    profession.title.toLowerCase().includes(term),
                ),
            )
            .map((profession) => `p-${profession.typeGuid}`),

        ...(serviceTypes ?? [])
            .filter((serviceType) =>
                terms.some((term) =>
                    serviceType.title.toLowerCase().includes(term),
                ),
            )
            .map((serviceType) => `s-${serviceType.typeGuid}`),
    ];

    return (
        <Link
            to={{
                pathname: "/clinicians/find",
                search: `?serviceType=${encodeURIComponent(typeIds.join(","))}`,
            }}
            className="rounded-3xl outline-2 -outline-offset-1 outline-neutral-200 hover:outline-darkgreen-500/50 focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-darkgreen-500/60 active:outline-darkgreen-500/60"
        >
            <Badge variant="white" size="xl" className="h-full">
                {title}
            </Badge>
        </Link>
    );
};
